import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import useTemplates from "../../../services/Whatsapp/useTemplates";
import "../../whatsapp/WhatsApp.css";
import { GlobalContext } from "../../../Context/GlobalContext";

const CampaignTesting = ({ formData, back, next }) => {
  const { executeTemplate } = useTemplates();
  const [testNumber, setTestNumber] = useState("");
  const [loading, setLoading] = useState(false);
const { userID } = useContext(GlobalContext); 

  const decodeText = (text) => {
    try {
      return atob(text);
    } catch {
      return text;
    }
  };

  // ===== SAME EXTRACTION LOGIC AS STEP 3 =====
  const headerText = decodeText(
    formData.template?.components?.find((c) => c.type === "HEADER")?.text || "",
  );

  const bodyText = decodeText(
    formData.template?.components?.find((c) => c.type === "BODY")?.text || "",
  );

  const footerText = decodeText(
    formData.template?.components?.find((c) => c.type === "FOOTER")?.text || "",
  );

  const buttonComponent = formData.template?.components?.find(
    (c) => c.type === "BUTTONS",
  );

  const buttons = buttonComponent?.buttons || [];

  // ===== SEND TEST =====
  const handleSendTest = async () => {
    if (!testNumber) {
      return toast.error("Enter mobile number");
    }

    const normalizedNumber = testNumber.startsWith("91")
      ? testNumber
      : `91${testNumber}`;

    const payload = {
  userid: userID,
  secret: "string",
  messaging_product: "whatsapp",
  type: "template",
  templateName: formData.template?.name,
  templateID: formData.template?.id,
  languageCode: formData.template?.language || "en",
  contacts: [normalizedNumber],
  headerParams: formData.headerParams || [],
  bodyParams: formData.bodyParams || [],
};

    try {
      setLoading(true);

      const res = await executeTemplate(payload);

      if (res?.responseCode === "00") {
        toast.success("Test message sent successfully");
      } else {
        toast.error(res?.responseMessage);
      }
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <div className="w-full px-10 py-6 montserrat-font-1">
      <div className="grid grid-cols-12 gap-10 montserrat-font-1">
        {/* LEFT SIDE */}
        <div className="col-span-7 space-y-6 montserrat-font-1">
          <h2 className="text-2xl font-semibold">Test Campaign</h2>

          <input
            type="text"
            placeholder="Enter Mobile Number For Testing"
            value={testNumber}
            onChange={(e) => setTestNumber(e.target.value)}
            className="w-full border rounded-lg px-4 py-3"
          />

          <button
            onClick={handleSendTest}
            disabled={loading}
            className="px-6 py-2 border border-blue-600 text-blue-600 rounded-md"
          >
            {loading ? "Sending..." : "Send Test Message"}
          </button>

          <div className="flex justify-start gap-4 pt-10">
            <button onClick={back} className="px-6 py-2 bg-gray-300 rounded-md">
              Previous
            </button>

            <button
              onClick={next}
              className="px-8 py-2 bg-blue-600 text-white rounded-md"
            >
              Next
            </button>
          </div>
        </div>

        {/* RIGHT MOBILE PREVIEW */}
        <div className="col-span-5 flex justify-center montserrat-font-1">
          <div className="mobile-card montserrat-font-1">
            <div className="mobile-card-int">
              <div className="mobile-top">
                <div className="mobile-speaker"></div>
                <div className="mobile-camera">
                  <div className="mobile-int"></div>
                </div>
              </div>

              <div className="mobile-btn1"></div>
              <div className="mobile-btn2"></div>
              <div className="mobile-btn3"></div>

              <div className="bubble-container">
                <div className="message-bubble message-bubble-animate">
                  {headerText && (
                    <div className="header-text">{headerText}</div>
                  )}

                  {bodyText && <div className="body-text">{bodyText}</div>}

                  {footerText && (
                    <div className="footer-text">{footerText}</div>
                  )}

                  <p className="message-time">
                    {new Date().toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                </div>

                {/* BUTTON PREVIEW SAME AS STEP 3 */}
                {buttons.length > 0 && (
                  <div className="button-bubble button-bubble-animate montserrat-font-1">
                    {buttons.map((btn, index) => (
                      <div key={index} className="button-text">
                        {btn.text}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default CampaignTesting;
